window.addEventListener('DOMContentLoaded',function () 
{
    

    var image_click = document.querySelectorAll(".color_image");
    for (let i = 0; i < image_click.length; i++) 
    {
        const single_image_click = image_click[i];
        single_image_click.addEventListener("click",function()
        {
           $('.color_selection_overlay').addClass('active');
           $('.color_selection_popup').addClass('active');
        });
    }

    var display_image_click = document.querySelectorAll(".display_color_image");
    for (let i = 0; i < display_image_click.length; i++) 
    {
        const single_image_click = display_image_click[i];
        single_image_click.addEventListener("click",function()
        {
           $('.color_selection_overlay').addClass('active');
           $('.color_selection_popup').addClass('active');
        });
    }
    


    function closePopup()
    {
        var number_of_nail_selection  = parseInt($('.color_button_wrapper .option_button.active').attr('data-number-of-colors')); 

        var selected_color_swatch = $('.color_selection_popup .color_section_wrapper .color_item.done').length;
        if (number_of_nail_selection == selected_color_swatch)
        {
            
            $('.choose_style_button').addClass('hidden');
            $('.custom_product_buy_buttons').removeClass('hidden');
            $('.sticky-choose_style_button').addClass('hidden');
            $('.active_add_to_cart_button').removeClass('hidden');
            $('.custom_add_to_cart_button').addClass('hidden');
        }
    }

    $(".single_nail_color_wrapper").on("click",function(e) 
    {
        e.stopPropagation();
        var number_of_nail_selection  = parseInt($('.color_button_wrapper .option_button.active').attr('data-number-of-colors')); 
        
        var selected_color_swatch = $('.color_selection_popup .color_section_wrapper .color_item.done').length;
        

        if ($(this).hasClass('selected_color_swatch') || number_of_nail_selection == selected_color_swatch) 
        {

            return false;
        }
        
        var nail_image_src= $(this).find(".nail_color_image img").attr('src');
        var color_featured_image= $(this).find('.nail_color_image').attr('data-featured-image');
        $(this).parents('.wi_popup_wrapper').find('.popup_image_wrapper img').attr('src', color_featured_image);
        
        var data_colorname= $(this).find('.nail_color_image').attr('data-colorname');
        var data_product_sku= $(this).find('.nail_color_image').attr('data-product-sku');
        $(this).addClass('selected_color_swatch');
        $('.wi_selected_color_name').text(data_colorname.replaceAll('_', ' ').split(' - ')[0]);
        var targetEle = $('.color_item.active_selection .color_image');
        var target_image= $(targetEle).find('img');
        targetEle.addClass('active').attr('data-colorname', data_colorname.replace(' ', '_'));
        targetEle.find('img').attr('src', nail_image_src);

       
        $(targetEle).parent().attr('data-colorname', data_colorname.replace(' ', '_'));
        
        targetEle.find('.color_name p').addClass('hidden');
        targetEle.find('.hidden_color_name').val(data_colorname.replace('_', ' ') + ' - ' + data_product_sku);
        
        $(target_image).parents('.color_item').addClass('done').addClass('selected_color_swatch').removeClass('active_selection');
        var popup_items = $('.color_popup_content_wrapper .color_item:not(.done)');
        $(popup_items[0]).addClass('active_selection');
        var display_items = $('.display_color_section_wrapper .color_item:not(.done)');
        $(display_items[0]).addClass('active_selection');
        
        
        setTimeout(() => {  
            closePopup();
        }, 200);
        
    });

    
    
    $(document).on("click",".close_icon",function(e) 
    {   
        e.stopPropagation();
        if ($(this).parents().hasClass('nail_color_image'))
        {
            var data_colorname= $(this).parents('.nail_color_image').attr('data-colorname');
        }
        else
        {
            var data_colorname= $(this).parents('.color_image').attr('data-colorname');
        }
        
        var remove_border= $('[data-colorname="'+ data_colorname +'"]');
        
        $(remove_border).removeClass('active');
        $(remove_border).parents('.color_item').removeClass('done');
        $(remove_border).parent().removeClass('selected_color_swatch');
        
        $('[data-colorname="'+ data_colorname + '"]:not(.nail_color_image):not(.single_nail_color_wrapper)').find('img').attr('src', '');
        $(remove_border).find('.color_name p').removeClass('hidden');
        var popup_items = $('.color_popup_content_wrapper .color_item:not(.done)');
        $('.color_item').removeClass('active_selection');
        $(popup_items[0]).addClass('active_selection');
        var display_items = $('.display_color_section_wrapper .color_item:not(.done)');
        $(display_items[0]).addClass('active_selection');

        $('.choose_style_button').removeClass('hidden');
        $('.custom_product_buy_buttons').addClass('hidden');
        $('.custom_add_to_cart_button').removeClass('hidden');
        $('.active_add_to_cart_button').addClass('hidden');
        return false;
    });

    $(".nail_color_image .close_icon").on("click",function(e) 
    {
        e.stopPropagation();
        $(this).parents('.single_nail_color_wrapper').removeClass('selected_color_swatch');
        var data_colorname= $(this).parents('.single_nail_color_wrapper').find('.nail_color_image').attr('data-colorname');
        var remove_same_color= $(this).parents('.color_popup_content_wrapper').find('.color_image[data-colorname="'+ data_colorname + '"]');
        $(remove_same_color).find('img').attr('src', '');
        $(remove_same_color).removeClass('active');
        $(remove_same_color).parents('.color_item');
        $(remove_same_color).parents('.color_item').css("border", "transperent");
        $(remove_same_color).parents('.color_item').find("p").removeClass('hidden');

        $('.color_section_wrapper .color_item[data-colorname="'+ data_colorname + '"]').removeClass('done').removeClass('selected_color_swatch');
        $('.color_section_wrapper .color_item[data-colorname="'+ data_colorname + '"] .color_image').removeClass('active');
        $('.color_section_wrapper .color_item[data-colorname="'+ data_colorname + '"]').find('img').attr('src', '');
        $('.color_section_wrapper .color_item[data-colorname="'+ data_colorname + '"]').find("p").removeClass('hidden');
        var popup_items = $('.color_popup_content_wrapper .color_item:not(.done)');
        $('.color_item').removeClass('active_selection');
        $(popup_items[0]).addClass('active_selection');
        var display_items = $('.display_color_section_wrapper .color_item:not(.done)');
        $(display_items[0]).addClass('active_selection');
        $('.custom_product_buy_buttons').addClass('hidden');
        $('.choose_style_button').removeClass('hidden');
        $('.custom_add_to_cart_button').removeClass('hidden');
        $('.active_add_to_cart_button').addClass('hidden');
    });
    
    
    $(".svg_close_icon").on("click",function(e) 
    {
        $('.color_selection_overlay').removeClass('active');
        $('.color_selection_popup').removeClass('active');
    });
    
    $(document).on("click",".color_selection_overlay",function(e) 
    {   
        if ($(this).hasClass('color_selection_overlay'))
        {
            $('.color_selection_overlay').removeClass('active');
        }
    });
    
    $(".filter_name").on("click",function(e) 
    {
        
        var filter_name= $(this).attr('data-filter-name');
        $('.filter_name p').removeClass('active');
        $(this).find('p').addClass('active');
        if (filter_name == "alle") 
        {
            $('.single_nail_color_wrapper').show();
        }
        else
        {
            $('.single_nail_color_wrapper').hide();
            $('.'+ filter_name).show();
        }
    });

    $(".choose_style_button").on("click",function(e) 
    {
        $('.color_selection_overlay').addClass('active');
        $('.color_selection_popup').addClass('active');
    });
    
    $(".zoom_icon").on("click",function(e) 
    {
        var image_src= $(this).parents('.nail_color_image').find('img').attr('src');
        $('.zoom_nail_image_overlay').addClass('zoom_image');
        $('.zoom_nail_image_overlay img').attr('src', image_src );
    });
    
    $(".close_zoom_image").on("click",function(e) 
    {
        $('.zoom_nail_image_overlay').removeClass('zoom_image');
    });

    
    async function removeExistingStarterKit(cb) 
    {   
        var updates = {};
        await $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function(cart)
            {
                //  check if cart.items has properties._type == 'bundle_product'
                var items = cart.items;
                
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.properties._type == 'starter_kit_product') {
                        updates[item.variant_id] = 0;
                    }
                    if (item.properties._type == 'main_product') {
                        updates[item.variant_id] = 0;
                    }
                }
            }   
          });

          await $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates
            },
            dataType: 'json',
            success: function (data) {
                cb()
            }
        });

        
    }
    
    var starter_kit_products = [];
    
    $(".active_add_to_cart").on("click",function() 
    {   

        $('.color_selection_overlay').removeClass('active'); 
        $('.color_selection_popup').removeClass('active'); 
        removeExistingStarterKit(function() 
        {
            var selected_items = $('.single_nail_color_wrapper.selected_color_swatch');
            this.miniCart = document.querySelector('mini-cart');
            this.drawer = document.querySelector('cart-drawer');
            let sections = this.miniCart.getSectionsToRender().map((section) => section.section);
            sections = sections.filter(function (el) {
                return el != null;
            });
            let formData = {
                'items': 
                [
                    {
                        'id': $('[name="id"]').val(),
                        'quantity': 1, 
                        'properties': {
                            '_type': 'main_product'
                        }
                    }
                ],
                sections:sections
            };

            for (let i = 0; i < selected_items.length; i++) {
                const selected_item = selected_items[i];
                var variant_id = $(selected_item).attr('data-variant-id');

                formData.items.push(
                    {
                        'id': variant_id,
                        'quantity': 1, 
                        'properties': {
                            '_type': 'starter_kit_product'
                    }
                });

                starter_kit_products.push({
                    'product_image': $(selected_item).attr('data-product-image'),
                    'product_title': $(selected_item).attr('data-product-title'),
                    // 'product_vendor': $(selected_item).attr('data-product-vendor'),
                });
            }
            var $this = this.miniCart;
            var $thisDrawer = this.drawer;
            
            $.ajax
                ({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: formData,
                    dataType: 'json',
                    success: function (data) {
                        
                        const parsedState = data;
                        $this.getSectionsToRender().forEach((section => {
                            const element = document.getElementById(section.id);
                            if (element) {
                              const elementToReplace = element.querySelector(section.selector) || element;
                  
                              if (elementToReplace && parsedState.sections[section.section]) {
                                elementToReplace.innerHTML =
                                $this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                              }
                            }
                          }));

                          $thisDrawer.openMenuDrawer();
                        
                    }
                });
        });    
    });

    function removeExistingColorSwatch()
    {
        $('.color_item').removeClass('selected_color_swatch').removeClass('done');
        $('.color_item').removeClass('active_selection');
        $('.color_item:first-child').addClass('active_selection');
        $('.color_image').removeClass('active');
        $('.color_name p').removeClass('hidden');
        $('.single_nail_color_wrapper').removeClass('selected_color_swatch');
        $('.choose_style_button').removeClass('hidden');
        $('.custom_product_buy_buttons').addClass('hidden');
        $('.custom_add_to_cart_button').removeClass('hidden');
        $('.active_add_to_cart_button').addClass('hidden');
    }
    
    $(".color_button_wrapper .option_button").on("click", function() 
    {
        $('.color_button_wrapper .option_button').removeClass('active');
        $(this).addClass('active');
    
        var previous_no_of_colors = parseInt($('.pick_number_of_nails span').text());
        var new_no_of_colors = parseInt($(this).attr('data-number-of-colors'));
    
        var selected_colors_count = $('.single_nail_color_wrapper.selected_color_swatch').length;
    
        if (selected_colors_count > new_no_of_colors) {
            removeExistingColorSwatch();
        }
    
        setTimeout(() => {  
            var original_price = $('.color_button_wrapper .option_button.active').attr('data-original-price');
            var compare_price = $('.color_button_wrapper .option_button.active').attr('data-compare-price');
            var save_amount = $('.color_button_wrapper .option_button.active').attr('data-save-amount');
            var variant_id = $('.color_button_wrapper .option_button.active').attr('data-variant-id');
            $(this).parents('.product__info-container').find('[name="id"]').val(variant_id);
            $(this).parents('.product__info-container').find('.price__regular').find('.price-item--regular bdi').text(original_price);
            $(this).parents('.product__info-container').find('.price__compare').find('.price-item--regular bdi').text(compare_price);
            $(this).parents('.product__info-container').find('.save_amount').find('.save_amount_price bdi').text("Save " + save_amount);
        }, 300);
    
        var no_of_color = $(this).attr('data-number-of-colors');
    
        $('.pick_number_of_nails span').text(no_of_color);
        $('.choose_color_title h5 span').text(no_of_color);
    
        if (no_of_color == "3") {
            $('.wi_color_item').addClass('hidden');
        } else {
            $('.wi_color_item').removeClass('hidden');
        }
    });


   
            
    $(document).on("click",".search_color",function(e)
    {
        e.stopPropagation();
    });

    $('.search_color').keydown(function()
    {
        setTimeout(() => 
        {
            var search_color_text = this.value;
            var color_text = search_color_text.toLowerCase();
            var color_name= $('.single_nail_color_wrapper');
            $(color_name).hide();
            for (let i = 0; i < color_name.length; i++) {
                const single_color_name = color_name[i];
                var data_color_name= $(single_color_name).attr('data-colorname');
                var replace_color_name = data_color_name.replace('_', ' ').toLowerCase();
               if (replace_color_name.includes(color_text))
               {
                   $(single_color_name).show(); 
               }
            }
        }, 100);
    });

    
});


$(document).ready(function()
{
    $('.wi_filter_wrapper').slick
    ({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg></button>'
    });
});